<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-9">                
                <div class="row mt-4">
                    <div class="multisteps-form mb-9">
                        <div class="col-12 col-lg-12 m-auto">
                            <div class="card">
                                <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                                    <div class="bg-gradient-success shadow-success border-radius-lg pt-4 pb-3">
                                        <div class="multisteps-form__progress">
                                            <button class="multisteps-form__progress-btn js-active position-relative" type="button">                                                
                                                <span>{{ $t('settings.New_attribute') }}</span>                                                
                                            </button>                                            
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="bg-white">
                                        <div class="row mt-4">
                                            <div class="col-4">
                                                <div class="input-group input-group-static null">
                                                <label>{{ $t('settings.GroupCode') }} *</label>
                                                <input v-model="state.groupCode" type="text" class="form-control form-control-default" :placeholder="$t('settings.GroupCode')">
                                                <span v-if="v$.groupCode.$error" class="text-sm text-danger">
                                                    {{ v$.groupCode.$errors[0].$message }}
                                                </span>
                                                </div>
                                            </div>
                                            <div class="col-4">
                                                <div class="input-group input-group-static null">
                                                <label>{{ $t('settings.Group') }} *</label>
                                                <input v-model="state.group" type="text" class="form-control form-control-default" :placeholder="$t('settings.Group')">
                                                <span v-if="v$.group.$error" class="text-sm text-danger">
                                                    {{ v$.group.$errors[0].$message }}
                                                </span>
                                                </div>
                                            </div>
                                            <div class="col-4">
                                                <div class="input-group input-group-static null">
                                                <label>{{ $t('settings.AttributeCode') }}</label>
                                                <input v-model="state.attributeCode" type="text" class="form-control form-control-default" :placeholder="$t('settings.AttributeCode')">              
                                                </div>
                                            </div>
                                        </div>                                        
                                        <div class="row mt-4">
                                            <div class="col-4">
                                                <div class="input-group input-group-static null">
                                                <label>{{ $t('settings.Attribute') }}</label>
                                                <input v-model="state.attribute1" type="text" class="form-control form-control-default" :placeholder="$t('settings.Attribute')">            
                                                </div>
                                            </div>
                                            <div class="col-4">
                                                <div class="input-group input-group-static null">
                                                <label>{{ $t('settings.DataType') }}</label>  
                                                <select id="datatype" v-model="state.datatype" class="form-control form-control-default">
                                                    <option value="">{{ $t('settings.Select_datatype') }}</option>
                                                    <option v-for="item in state.dataTypes" :key="item.id" :value="item.id">
                                                        {{ item.name }}
                                                    </option>
                                                </select>
                                                </div>
                                            </div>
                                            <div class="col-4">
                                                <div class="input-group input-group-static null">
                                                <label>{{ $t('settings.ReferenceType') }}</label>  
                                                <select id="referenceTypeId" v-model="state.referenceTypeId" class="form-control form-control-default">
                                                    <option value="">{{ $t('settings.Select_referencetype') }}</option>
                                                    <option v-for="item in state.referenceTypes" :key="item.id" :value="item.id">
                                                        {{ item.name }}
                                                    </option>
                                                </select>
                                                </div>
                                            </div>          
                                        </div>
                                        <div class="row mt-4">
                                            <div class="col-4">
                                                <div class="input-group input-group-static null">
                                                    <label class="d-block mb-1" style="width: inherit;">{{ $t('settings.Required') }}</label>
                                                    <div class="d-block mt-1">
                                                        <material-switch v-model="state.required" id="required" name="required" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-4">
                                                <div class="input-group input-group-static null">
                                                    <label>{{ $t('settings.SortOrder') }}</label>
                                                    <input v-model="state.sortorder" type="text" class="form-control form-control-default" :placeholder="$t('settings.SortOrder')">
                                                    <span v-if="v$.sortorder.$error" class="text-sm text-danger">
                                                        {{ v$.sortorder.$errors[0].$message }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-12 mt-4">
                                        <router-link to="/settings" class="btn btn-sm bg-gradient-danger float-start">{{ $t('common.Cancel') }}</router-link>
                                        <button v-on:click="saveForm" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('common.Save') }}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>
</template>

<script>
import MaterialSwitch from "@/components/MaterialSwitch.vue";
import * as Choices from "choices.js";
import useVuelidate from '@vuelidate/core'
import { required, helpers, } from '@vuelidate/validators'
import { reactive, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import axios from 'axios'

    export default {
        name: 'Attribute_create_page',

        setup() {

            const { t } = useI18n()            

            const state = reactive ({
                groupCode: '',
                group: '',
                attributeCode: '',
                attribute1: '',
                datatype: '',
                required: false,
                sortorder: '',
                referenceTypeId: '',
                referenceTypes:[],
                dataTypes:[]
            })
        
            const integerOnly = helpers.withMessage(
                t('common.Integer_only'),
                value => {
                    if (value === '' || value === null || value === undefined) return true; // allow empty
                    return /^[0-9]+$/.test(value); // only allow integers
                }
            )
            
            const rules = computed(() => {            
                return {
                    groupCode: { required: helpers.withMessage(t('common.Required'), required) },
                    group: { required: helpers.withMessage(t('common.Required'), required) },
                    sortorder: { integerOnly }                
                }
            })
        
            const v$ = useVuelidate(rules, state)

            return {
                state,
                v$,                
                choicesReferenceType: null,
                choicesDataType: null,
            }
        },    
    components: {
        MaterialSwitch,
    },    
    async mounted() {
        try {            
            this.$store.commit('setShowLoading', true);
                                
            await this.fetchAllReferenceTypeData();
            await this.fetchAllDataTypeData();
        } catch (e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
            this.$store.commit('setShowLoading', false);
        }
    },
    methods: 
    {  
        async fetchAllReferenceTypeData() {
            try {
                const response = await axios.get("referencetype/getall"); 
                const result = response.data;

                if (result.success && Array.isArray(result.data)) {
                    this.state.referenceTypes = result.data;

                    this.$nextTick(() => {
                        this.initializeChoicesDropdown({
                            id: "referenceTypeId",
                            dataList: this.state.referenceTypes,
                            selectedValue: this.state.referenceTypeId,
                            instanceKey: "choicesReferenceType"
                        });
                    });
                } else {
                    this.$showError('errors.Error_fetching_referencetype');
                }
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            }
        },
        async fetchAllDataTypeData() {
            try {
                const staticData = [
                { id: 'int', name: 'Intiger' },
                { id: 'dec', name: 'Decimal' },
                { id: 'char', name: 'Character' },
                { id: 'mult', name: 'Multiline' },
                { id: 'date', name: 'Date' },
                { id: 'ref', name: 'Reference' }
                ];
                this.state.dataTypes = staticData;

                this.$nextTick(() => {
                    this.initializeChoicesDropdown({
                        id: "datatype",
                        dataList: this.state.dataTypes,
                        selectedValue: this.state.datatype,
                        instanceKey: "choicesDataType"
                    });
                });            
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            }
        },
        initializeChoicesDropdown({ id, dataList, selectedValue, instanceKey }) {
            const element = document.getElementById(id);
            if (!element || element.tagName !== "SELECT") {
                console.error(`Choices: Invalid or missing select element with ID "${id}".`);
                return;
            }

            // Destroy previous instance if it exists
            if (this[instanceKey]) {
                this[instanceKey].destroy();
            }

            // Initialize new Choices instance
            this[instanceKey] = new Choices(element, {
                searchEnabled: true,
                itemSelectText: '',
                shouldSort: false,
                placeholder: true,
            });

            // Set selected value if it exists in list
            if (selectedValue) {
                const optionExists = dataList.some(item => item.id === selectedValue);
                this[instanceKey].setChoiceByValue(optionExists ? [selectedValue] : '');
            }
        },
        async saveForm() {
            this.submitForm();
        },           
        async submitForm() {
            try {
                const isValid = await this.v$.$validate();

                if (!isValid) {
                    return;
                } 
                
                this.$store.commit('setShowLoading', true);

                const formData = {
                    groupCode: this.state.groupCode,
                    group: this.state.group,
                    attributeCode: this.state.attributeCode,
                    attribute1: this.state.attribute1,
                    datatype: this.state.datatype,
                    sortorder: this.state.sortorder,
                    referenceTypeId: this.state.referenceTypeId,
                    required: this.state.required
                };

                const response = await axios.post('Attribute/save', formData);
                this.gets = response.data;

                if (this.gets.success) {
                    this.$showSuccess('errors.Success_new_atribute_added_successfully');
                    
                    this.$router.push('/settings');
                } else {
                    this.$showError('errors.Contact_system_admin');
                }
            }
            catch(e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.$store.commit('setShowLoading', false);
            }
        }
    }
}
</script>
<style scoped>  
    .multisteps-form__progress-btn.js-active span {
        color: #fff !important;  
    }
</style>